import type { MeResponse } from '@crm/shared'
import type { QueryClient } from '@tanstack/react-query'
import { api, ApiClientError } from './api'

export const ME_QUERY_KEY = ['auth', 'me'] as const

export const meQueryOptions = {
  queryKey: ME_QUERY_KEY,
  queryFn: () => api.get<MeResponse>('/api/auth/me'),
  staleTime: 5 * 60 * 1000,
  retry: false,
} as const

/**
 * Resolves the session for route guards. A 401 is an answer ("not signed in"),
 * not an error — so it returns null rather than throwing, and the caller
 * decides where to redirect.
 */
export async function fetchMe(queryClient: QueryClient): Promise<MeResponse | null> {
  try {
    return await queryClient.ensureQueryData(meQueryOptions)
  } catch (error) {
    if (error instanceof ApiClientError && error.isUnauthorized) return null
    throw error
  }
}
